export const profType = {
  1: 'Risk Profile SI - 1'
  // 2: 'Loss Profile SI - 2',
  // 3: 'Risk & Loss Profile SI - 3',
  // 4: 'Risk Profile Premium - 4'
}
